import { PageTitleConstructor } from '@/study-search/models/page-title';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import {
	SearchPageSwitchRequestedEvent,
	SearchPageSwitchTabsAvailableEvent,
	SearchType
} from '@studyportals/search-page-interface';
import { ISwitchTab } from '@studyportals/search-page-interface';
import { computed, ref } from 'vue';

export class NavigationBar implements ISubscriber<SearchPageSwitchTabsAvailableEvent> {
	public readonly switchTabs = ref<ISwitchTab[]>([]);
	public readonly searchTypeStudy = SearchType.STUDY;
	private readonly pageTitleConstructor = new PageTitleConstructor();

	public constructor() {
		const eventAggregationService = window.EventAggregationService;
		if (eventAggregationService === undefined) {
			return;
		}

		eventAggregationService.subscribeTo(SearchPageSwitchTabsAvailableEvent.EventType, this, true);
	}

	public notify(event: SearchPageSwitchTabsAvailableEvent): void | Promise<void> {
		if (SearchPageSwitchTabsAvailableEvent.is(event)) {
			this.switchTabs.value = event.switchTabs;
		}
	}

	public title = computed((): string => {
		return this.pageTitleConstructor.getPageTitle();
	});

	public switchToTab(type: SearchType): void {
		if (window.EventAggregationService === undefined) {
			return;
		}

		window.EventAggregationService.publishTo(
			SearchPageSwitchRequestedEvent.EventType,
			new SearchPageSwitchRequestedEvent(type)
		);
	}
}
